<section class=" content2-bg-image no-padding cover-background xs-bg-none border-none bg-img-ten header-margin-top-medium"
    id="" data-img-size="(W)1920px X (H)590px" style="background: linear-gradient(rgba(0, 0, 0, 0.00784314), rgba(0, 0, 0, 0.00784314)), url('assets/images/bg-image/bg-home-empresa.jpg') fixed;">
    <div class="container sm-width-100 sm-no-padding">
        <div class="bg-cream  width-80 sm-width-60 xs-width-100 content-style1 padding-four md-padding-eight sm-padding-eighteen">
            <!-- section title -->
            <h2 class="title alt-font title-extra-large-2 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom">Área
                de usuario</h2>
            <!-- end section title -->
            <form [formGroup]="formRecuperar" class="form-signin" (ngSubmit)="onSubmit()">
                <input type="text" name="name" data-email="required" id="name" placeholder="* Nombre de usuario o Email" class="medium-input border-radius-8"
                    formControlName="username" [ngClass]="{'is-invalid': submitted && f.username.errors }">
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                    <div *ngIf="f.username.errors.required">Valor requerido</div>
                </div>                
                <div style="display: inline-flex">
                    <button class="btn-medium btn-circle btn bg-dark-brown text-white" type="submit">RECUPERAR</button>
                </div>
            </form>            
            <br>
            <a routerLink="/registro" routerLinkActive="active" class="text-orange float-right">¿Aún no posee una cuenta? Regístrese aquí.</a><br>            
        </div>
    </div>
</section>